import { defaultConfig } from '@chakra-ui/react';

import { animations } from './animation';
import { colors } from './colors';
import { cursor } from './cursor';
import { fonts } from './fonts';
import { radii } from './radii';
import { sizes } from './sizes';

const tokens = {
    ...defaultConfig.theme?.tokens,
    animations,
    cursor,
    sizes,
    colors,
    fonts,
    radii,
};

export { tokens };
